import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from "../config.js";
import { useToast } from '../context/ToastContext.js';

function EditAthlete({ athletes, setAthletes }) {
  const toast = useToast();
  const { id } = useParams();
  const athleteId = Number(id);
  const navigate = useNavigate();
  const [athlete, setAthlete] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (!user || !['admin','coach'].includes(user.role)) {
      toast.error('You do not have permission to edit athletes.');
      navigate('/');
      return;
    }

    const athleteToEdit = athletes.find(a => a.id === athleteId);
    if (athleteToEdit) {
      setAthlete(athleteToEdit);
      setLoading(false);
    } else {
      // Fetch from backend if not in local state
      axios.get(`${API_BASE_URL}/athletes/${athleteId}`, {
        headers: { Authorization: `Bearer ${user.token}` }
      })
      .then(res => setAthlete(res.data))
      .catch(err => console.error('Failed to fetch athlete:', err))
      .finally(() => setLoading(false));
    }
  }, [athleteId, athletes, navigate, user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAthlete(prev => ({
      ...prev,
      [name]: ['height','weight'].includes(name) ? Number(value) : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.put(`${API_BASE_URL}/athletes/${athlete.id}`, athlete, {
        headers: { Authorization: `Bearer ${user.token}` }
      });

      setAthletes(prev => prev.map(a => a.id === response.data.id ? response.data : a));
      navigate('/athletes');

    } catch (err) {
      console.error('Error updating athlete:', err);
      toast.error(err.response?.data?.error || 'Failed to update athlete.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div>Loading athlete...</div>;
  if (!athlete) return <div>Athlete not found.</div>;

  return (
    <div>
      <h2>Edit Athlete</h2>
      <form onSubmit={handleSubmit}>
        <div><label>Name:</label>
          <input type="text" name="name" value={athlete.name} onChange={handleChange} required />
        </div>
        <div><label>Date of Birth:</label>
          <input type="date" name="dob" value={athlete.dob} onChange={handleChange} required />
        </div>
        <div><label>Height (cm):</label>
          <input type="number" name="height" value={athlete.height} onChange={handleChange} required />
        </div>
        <div><label>Weight (kg):</label>
          <input type="number" name="weight" value={athlete.weight} onChange={handleChange} required />
        </div>
        <div><label>Email Address:</label>
          <input type="email" name="email" value={athlete.email} onChange={handleChange} required />
        </div>
        <div><label>Phone Number:</label>
          <input type="tel" name="phone" value={athlete.phone} onChange={handleChange} required />
        </div>
        <div><label>Contact Person in Case of Injury:</label>
          <input type="text" name="emergency_contact_name" value={athlete.emergency_contact_name} onChange={handleChange} required />
        </div>
        <div><label>Contact Phone Number:</label>
          <input type="tel" name="emergency_contact_phone" value={athlete.emergency_contact_phone || ''} onChange={handleChange} required />
        </div>
        <div><label>USAG ID:</label>
          <input type="text" name="usag_id" value={athlete.usag_id || ''} onChange={handleChange} placeholder="e.g. 1234567" maxLength={20} />
        </div>
        <button type="submit" disabled={submitting}>{submitting ? 'Saving...' : 'Save Changes'}</button>
      </form>
    </div>
  );
}

export default EditAthlete;
